import Home from "../modules/Home/index";
import CarrierAgreementMgmt from "../modules/CarrierAgreementMgmt/index";
import PolicyFee from "../modules/PolicyFee/index";
import Notifications from "../modules/NavBar/Notifications/index";
import Carrier from "../modules/CarrierAgreementMgmt/Carrier/index";
import Agreements from "../modules/CarrierAgreementMgmt/Agreements/index";
import OfficeSetting from "../modules/CarrierAgreementMgmt/OfficeSettings/index";
import ProducerCodesConfig from "../modules/CarrierAgreementMgmt/ProducerCodeConfig/index";
import Roles from "./Roles";
import ProducerConfiguration from "../modules/Utilities/ProducerConfiguration";
import LobTypes from "../modules/Utilities/ProducerConfiguration/LobType/index";
import Entity from "../modules/Utilities/Entity/index";
import OfficeStatus from "../modules/Utilities//Office/OfficeStatus/index";
// import EmailRecipient from "../modules/Utilities/EmailRecipient/index";
import ConfigureAgreement from "../modules/Utilities/ConfigureAgreement/index";
import PolicyType from "../modules/Utilities/ConfigureAgreement/PolicyType/index";
import TargetSystem from "../modules/Utilities/Office/TargetSystem/index";
import SalesLead from "../modules/Utilities//ConfigureAgreement/SalesLead/index";
import Standard from "../modules/Utilities/ConfigureAgreement/Standard/index";
import PolicyTerm from "../modules/Utilities/PolicyTerms/index";
import OfficeConfiguration from "../modules/Utilities/Office/index";
// import OfficeHierarchyConfiguration from "../modules/Utilities/OfficeHierarchyConfiguration";
import FeeLevel from "../modules/Utilities/PolicyTerms/FeeLevel/index";
import FeeType from "../modules/Utilities/PolicyTerms/FeeType/index";
import Terms from "../modules/Utilities/PolicyTerms/index";
import OfficeBrand from "../modules/Utilities//Office/OfficeBrand/index";
import GLEntity from "../modules/Utilities/Office/GLEntity/index";
import OfficeDivision from "../modules/Utilities/Office/OfficeDivision/index";
import LicenseType from "../modules/Utilities/ConfigureAgreement/LicenseType/index";
import OfficeType from "../modules/Utilities/Office/OfficeType/index";
import Reports from "../modules/CarrierAgreementMgmt/Reports/index";
import EmployeeType from "../modules/Utilities/EmployeeConfiguration/EmployeeType/index";
import EmployeeConfiguration from "../modules/Utilities/EmployeeConfiguration";
import EmployeeStatus from "../modules/Utilities/EmployeeConfiguration/EmployeeStatus";
import EmploymentType from "../modules/Utilities/EmployeeConfiguration/EmploymentType";
import ModuleManagement from "../modules/Utilities/UserModuleandRoleMgt/ModuleManagement";
import UserModuleandRoleMgt from "../modules/Utilities/UserModuleandRoleMgt";
import UserManagement from "../modules/Utilities/UserModuleandRoleMgt/UsersManagement";
import BusinessOperation from "../modules/Utilities/BusinessOperation/index";
// import District from "../modules/Utilities/OfficeHierarchyConfiguration/District";
import Employees from "../modules/CarrierAgreementMgmt/Employees/Confie";
import OfficeHierarchy from "../modules/CarrierAgreementMgmt/OfficeHierarchy";
import DigitalAssets from "../modules/CarrierAgreementMgmt/DigitalAsset";
import Channel from "../modules/Utilities/Office/Channel/index";
import SalesType from "../modules/Utilities/Office/SalesType/index";
import OfficeOrigin from "../modules/Utilities/Office/OfficeOrigin/index";

import {
  HomeIcon,
  BuildingLibraryIcon,
  Bars3Icon,
  XMarkIcon,
  UserCircleIcon,
  NewspaperIcon,
  BuildingOfficeIcon,
  CogIcon,
  ServerStackIcon,
  AdjustmentsVerticalIcon,
  UsersIcon,
  ClipboardDocumentListIcon,
  EnvelopeIcon,
  ArchiveBoxIcon,
  CreditCardIcon,
  PresentationChartBarIcon,
  SignalIcon,
  TicketIcon,
  UserGroupIcon,
} from "@heroicons/react/24/solid";
import OfficeStatusDetails from "../modules/Utilities/Office/OfficeStatusDetails";
import { addLicenseType } from "../actions/Utilities/LicenseType";
const PrivateRoutesConfig = [
  {
    component: Home,
    path: "/home",
    title: "Home",
    permission: [Roles.Admin, Roles.GeneralUser, Roles.Viewer],
    icon: <HomeIcon className="h-4 w-4 float-left mr-2 " aria-hidden="true" />,
  },
  {
    component: CarrierAgreementMgmt,
    path: "/carrieragreementmgmt",
    title: "Carrier Agreement Management",
    permission: [Roles.Admin, Roles.GeneralUser, Roles.Viewer],
    icon: (
      <BuildingLibraryIcon
        className="h-4 w-4 float-left mr-2 "
        aria-hidden="true"
      />
    ),
    children: [
      {
        component: Carrier,
        path: "/carrieragreementmgmt/carriers",
        title: "Carrier Module",
        icon: <BuildingLibraryIcon className="h-3 w-3 float-left mr-2 " />,
        permission: [Roles.Admin, Roles.GeneralUser, Roles.Viewer],
      },
      {
        component: Agreements,
        path: "/carrieragreementmgmt/agreements",
        title: "Agreement Module",
        icon: <NewspaperIcon className="h-3 w-3 float-left mr-2 " />,
        permission: [Roles.Admin, Roles.GeneralUser, Roles.Viewer],
      },
      {
        component: OfficeSetting,
        path: "/carrieragreementmgmt/officesetting",
        title:
          localStorage.getItem("isFranchise") === "true"
            ? "Franchise Office Module"
            : "Office Module",
        icon: <BuildingOfficeIcon className="h-4 w-4 float-left mr-2 " />,
        permission: [Roles.Admin, Roles.GeneralUser, Roles.Viewer],
      },
      {
        component: ProducerCodesConfig,
        path: "/carrieragreementmgmt/producercodeconfig",
        title: "Producer Code Module",
        icon: <CogIcon className="h-4 w-4 float-left mr-2" />,
        permission: [Roles.Admin, Roles.GeneralUser, Roles.Viewer],
      },
      {
        component: Reports,
        path: "/carrieragreementmgmt/reports",
        title: "Reports Module",
        icon: <ClipboardDocumentListIcon className="h-4 w-4 float-left mr-2" />,
        permission: [Roles.Admin, Roles.GeneralUser, Roles.Viewer],
      },
      {
        component: Employees,
        path: "/carrieragreementmgmt/employees",
        title: "Employees Module",
        icon: <ClipboardDocumentListIcon className="h-4 w-4 float-left mr-2" />,
        permission: [Roles.Admin, Roles.GeneralUser, Roles.Viewer],
      },
      {
        component: OfficeHierarchy,
        path: "/carrieragreementmgmt/officehierarchy",
        title: "Office Hierarchy Module",
        icon: <ClipboardDocumentListIcon className="h-4 w-4 float-left mr-2" />,
        permission: [Roles.Admin, Roles.GeneralUser, Roles.Viewer],
      },
      {
        component: DigitalAssets,
        path: "/carrieragreementmgmt/digitalasset",
        title: "Digital Assets Module",
        icon: <ClipboardDocumentListIcon className="h-4 w-4 float-left mr-2" />,
        permission: [Roles.Admin, Roles.GeneralUser, Roles.Viewer],
      },
    ],
  },
  {
    component: PolicyFee,
    path: "/policyfee",
    title: "Policy Fee",
    icon: <ServerStackIcon className="h-4 w-4 float-left mr-2" />,
    permission: [Roles.Admin, Roles.GeneralUser, Roles.Viewer],
  },
  {
    component: Notifications,
    path: "/notifications",
    title: "Notifications",
    icon: <ServerStackIcon className="h-4 w-4 float-left mr-2" />,
    permission: [Roles.Admin, Roles.GeneralUser, Roles.Viewer],
  },
  {
    component: Entity,
    path: "/utilities/Entity/index",
    title: "Entity",
    mainTitle: "Utilities",
    permission: [Roles.Admin],
    icon: <ServerStackIcon className="ml-4 mt-1 h-4 w-4 float-left mr-2" />,
  },
  // {
  //   component: EmailRecipient,
  //   path: "/utilities/EmailRecipient/index",
  //   title: "Email Recipient",
  //   mainTitle: "Utilities",
  //   permission: [Roles.Admin],
  //   icon: <EnvelopeIcon className="ml-4 h-4 w-4 float-left mr-2" />,
  // },
  {
    component: LicenseType,
    path: "/utilities/LicenseType/index",
    title: "License Type",
    mainTitle: "Utilities",
    permission: [Roles.Admin],
    icon: <EnvelopeIcon className="ml-4 h-4 w-4 float-left mr-2" />,
  },

  {
    component: ProducerConfiguration,
    path: "/utilities/ProducerConfiguration",
    title: "Producer Configuration",
    mainTitle: "Utilities",
    permission: [Roles.Admin],
    icon: <CogIcon className="ml-4 mt-1 h-4 w-4 float-left mr-2" />,
    children: [
      {
        component: LobTypes,
        id: 1,
        path: "/utilities/ProducerConfiguration/LobType/index",
        title: "Lob Types",
        permission: [Roles.Admin],
        icon: <CogIcon className="h-4 w-4 float-left mr-2" />,
      },
    ],
  },
  {
    component: EmployeeConfiguration,
    path: "/utilities/EmployeeConfiguration",
    title: "Employee Configuration",
    mainTitle: "Utilities",
    permission: [Roles.Admin],
    icon: <UserGroupIcon className="ml-4 mt-1 h-4 w-4 float-left mr-2" />,
    children: [
      {
        component: EmployeeType,
        id: 1,
        path: "/utilities/EmployeeConfiguration/employeeType",
        title: "Employee Type",
        permission: [Roles.Admin],
        icon: <UsersIcon className="h-4 w-4 float-left mr-2" />,
      },
      {
        component: EmployeeStatus,
        id: 2,
        path: "/utilities/EmployeeConfiguration/employeeStatus",
        title: "Employee Status",
        permission: [Roles.Admin],
        icon: <AdjustmentsVerticalIcon className="h-4 w-4 float-left mr-2" />,
      },
      {
        component: EmploymentType,
        id: 3,
        path: "/utilities/EmployeeConfiguration/employmentType",
        title: "Employement Type",
        permission: [Roles.Admin],
        icon: <ArchiveBoxIcon className="h-4 w-4 float-left mr-2" />,
      },
    ],
  },
  {
    component: Entity,
    path: "/utilities/entity",
    title: "Entity",
    mainTitle: "Utilities",
    permission: [Roles.Admin],
    icon: <PresentationChartBarIcon className="h-4 w-4 float-left mr-2" />,
  },
  {
    component: ConfigureAgreement,
    path: "/utilities/configureagreement",
    title: "Agreement Configuration",
    mainTitle: "Utilities",
    permission: [Roles.Admin],
    icon: <CogIcon className="ml-4 mt-1 h-4 w-4 float-left mr-2" />,
    children: [
      {
        component: PolicyType,
        id: 1,
        path: "/utilities/configureagreement/policytype",
        title: "Policy Type",
        icon: <CogIcon className="ml-4 mt-0.5 h-4 w-4 float-left mr-2 " />,
        permission: [Roles.Admin],
      },
      {
        component: TargetSystem,
        id: 2,
        path: "/utilities/Office/targetsystem",
        title: "Target System",
        icon: (
          <AdjustmentsVerticalIcon className="ml-4 h-4 w-4 float-left mr-2 " />
        ),
        permission: [Roles.Admin],
      },
      {
        component: SalesLead,
        id: 3,
        path: "/utilities/configureagreement/saleslead",
        title: "Sales Lead",
        permission: [Roles.Admin],
        icon: <PresentationChartBarIcon className="h-4 w-4 float-left mr-2" />,
      },
      {
        component: Standard,
        id: 4,
        path: "/utilities/configureagreement/standard",
        title: "Standard",
        permission: [Roles.Admin],
        icon: <PresentationChartBarIcon className="h-4 w-4 float-left mr-2" />,
      },
      {
        component: LicenseType,
        id: 5,
        path: "/utilities/configureagreement/licensetype",
        title: "LicenseType",
        permission: [Roles.Admin],
        icon: <PresentationChartBarIcon className="h-4 w-4 float-left mr-2" />,
      },
    ],
  },
  {
    component: PolicyTerm,
    path: "/utilities/PolicyTerm",
    title: "Policy Fee Configuration",
    mainTitle: "Utilities",
    permission: [Roles.Admin],
    icon: (
      <ClipboardDocumentListIcon className="ml-4 mt-1 h-4 w-4 float-left mr-2" />
    ),
    children: [
      {
        component: FeeLevel,
        id: 1,
        path: "/utilities/PolicyTerm/feelevel",
        title: "Fee Level",
        permission: [Roles.Admin],
        icon: <ArchiveBoxIcon className="h-4 w-4 float-left mr-2" />,
      },
      {
        component: FeeType,
        id: 2,
        path: "/utilities/PolicyTerm/feetype",
        title: "Fee Type",
        permission: [Roles.Admin],
        icon: <CreditCardIcon className="h-4 w-4 float-left mr-2" />,
      },
      {
        component: Terms,
        id: 3,
        path: "/utilities/PolicyTerm/terms",
        title: "Policy Term",
        permission: [Roles.Admin],
        icon: <BuildingLibraryIcon className="h-4 w-4 float-left mr-2" />,
      },
    ],
  },
  {
    component: OfficeConfiguration,
    path: "/utilities/Office",
    title: "Office Configuration",
    mainTitle: "Utilities",
    permission: [Roles.Admin],
    icon: <BuildingOfficeIcon className="ml-4 mt-1 h-4 w-4 float-left mr-2" />,
    children: [
      {
        component: GLEntity,
        id: 1,
        path: "/utilities/Office/GLEntity",
        title: "GL Entity",
        permission: [Roles.Admin],
        icon: <ArchiveBoxIcon className="h-4 w-4 float-left mr-2" />,
      },
      {
        component: OfficeBrand,
        id: 2,
        path: "/utilities/Office/OfficeBrand",
        title: "Office Brand",
        permission: [Roles.Admin],
        icon: <BuildingOfficeIcon className="h-4 w-4 float-left mr-2" />,
      },
      {
        component: OfficeStatus,
        id: 3,
        path: "/utilities/Office/OfficeStatus",
        title: "Office Status",
        permission: [Roles.Admin],
        icon: <SignalIcon className="h-4 w-4 float-left mr-2" />,
      },
      {
        component: OfficeType,
        id: 4,
        path: "/utilities/Office/OfficeType/index",
        title: "Office Type",
        permission: [Roles.Admin],
        icon: <EnvelopeIcon className="ml-4 h-4 w-4 float-left mr-2" />,
      },
      {
        component: Channel,
        id: 5,
        path: "/utilities/Office/Channel/index",
        title: "Channel",
        permission: [Roles.Admin],
        icon: <EnvelopeIcon className="ml-4 h-4 w-4 float-left mr-2" />,
      },
      {
        component: SalesType,
        id: 6,
        path: "/utilities/Office/SalesType/index",
        title: "Sales Type",
        permission: [Roles.Admin],
        icon: <EnvelopeIcon className="ml-4 h-4 w-4 float-left mr-2" />,
      },

      {
        component: OfficeOrigin,
        id: 7,
        path: "/utilities/Office/OfficeOrigin/index",
        title: "Sales Type",
        permission: [Roles.Admin],
        icon: <EnvelopeIcon className="ml-4 h-4 w-4 float-left mr-2" />,
      },

      {
        component: BusinessOperation,
        id: 8,
        path: "/utilities/Office/BusinessOperation/index",
        title: "Business Operation",
        permission: [Roles.Admin],
        icon: <EnvelopeIcon className="ml-4 h-4 w-4 float-left mr-2" />,
      },
      {
        component: OfficeStatusDetails,
        id: 9,
        path: "/utilities/Office/officestatusdetails/index",
        title: "Office Status Details",
        permission: [Roles.Admin],
        icon: <EnvelopeIcon className="ml-4 h-4 w-4 float-left mr-2" />,
      },
      {
        component: OfficeDivision,
        id: 10,
        path: "/utilities/Office/OfficeDivision/index",
        title: "Office Division",
        permission: [Roles.Admin],
        icon: <EnvelopeIcon className="ml-4 h-4 w-4 float-left mr-2" />,
      },
    ],
  },

  // {
  //   component: OfficeHierarchyConfiguration,
  //   path: "/utilities/OfficeHierarchConfiguration",
  //   title: "Office Hierarchy Configuration",
  //   mainTitle: "Utilities",
  //   permission: [Roles.Admin],
  //   icon: <BuildingOfficeIcon className="ml-4 mt-1 h-4 w-4 float-left mr-2" />,
  //   children: [
  //     {
  //       component: District,
  //       id: 1,
  //       path: "/utilities/OfficeHierarchConfiguration/District",
  //       title: "District",
  //       permission: [Roles.Admin],
  //       icon: <BuildingOfficeIcon className="h-4 w-4 float-left mr-2" />,
  //     },
  //   ],
  // },

  {
    component: UserModuleandRoleMgt,
    path: "/utilities/UserModuleandRoleMgt/index",
    title: "User, Module and Role Management",
    mainTitle: "Utilities",
    permission: [Roles.Admin],
    icon: <UsersIcon className="h-4 w-4 float-left ml-4 mr-4 mt-0.5" />,
    children: [
      {
        component: UserManagement,
        id: 1,
        path: "/utilities/UserModuleandRoleMgt/UserManagement/index",
        title: "User Management",
        permission: [Roles.Admin],
        icon: <BuildingLibraryIcon className="h-4 w-4 float-left mr-2" />,
      },
      {
        component: OfficeStatus,
        id: 2,
        path: "/utilities/UserModuleandRoleMgt/ModuleManagement/index",
        title: "Role Management",
        permission: [Roles.Admin],
        icon: <TicketIcon className="h-4 w-4 float-left mr-2" />,
      },
      {
        component: ModuleManagement,
        id: 3,
        path: "/utilities/UserModuleandRoleMgt/ModuleManagement/index",
        title: "Module Management",
        permission: [Roles.Admin],
        icon: <ServerStackIcon className="h-4 w-4 float-left mr-2" />,
      },
    ],
  },
];

export default PrivateRoutesConfig;
